var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinnercircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#435BFF",
    stroke: "#435BFF",
    strokeWidth: 17,
    r: 15,
    cx: 40,
    cy: 65
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    dur: 0.9,
    values: "65;135;65;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: -0.4
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#435BFF",
    stroke: "#435BFF",
    strokeWidth: 17,
    r: 15,
    cx: 100,
    cy: 65
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    dur: 0.9,
    values: "65;135;65;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: -0.2
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#435BFF",
    stroke: "#435BFF",
    strokeWidth: 17,
    r: 15,
    cx: 160,
    cy: 65
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    calcMode: "spline",
    dur: 0.9,
    values: "65;135;65;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnercircle);
export default __webpack_public_path__ + "static/media/spinnercircle.ff5a5b139606d4c6d536b1966a482879.svg";
export { ForwardRef as ReactComponent };